var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.187 15.856a.474.474 0 00.673 0 .472.472 0 00-.001-.672l-4.457-4.456c.984-1.14 1.6-2.606 1.6-4.229A6.5 6.5 0 006.502 0a6.5 6.5 0 100 12.999c1.622 0 3.088-.616 4.227-1.599l4.458 4.456zM6.502.999a5.501 5.501 0 110 11.002A5.501 5.501 0 016.502 1z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.39db2c9bf67baac93d44f3ef939ed7f8.svg";
export { ForwardRef as ReactComponent };